import {
  createInitialIndicatorProjectQuery,
  IndicatorProjectQueriesState,
} from '../../models/IndicatorProjectQuery';
import {
  IndicatorProjectQueriesActionTypes,
  INDICATOR_PROJECT_QUERY_STARTED,
  INDICATOR_PROJECT_QUERY_SUCCEEDED,
  INDICATOR_PROJECT_QUERY_FAILED,
  RESET_INDICATOR_PROJECT_QUERY,
  RESET_INDICATOR_PROJECT_QUERIES,
} from '../actions/types';

const initialState: IndicatorProjectQueriesState = {};

const indicatorProjectQueriesReducer = (
  state = initialState,
  action: IndicatorProjectQueriesActionTypes,
): IndicatorProjectQueriesState => {
  switch (action.type) {
    case INDICATOR_PROJECT_QUERY_STARTED: {
      const { queryKey, requestId } = action.payload;
      return {
        ...state,
        [queryKey]: {
          ...createInitialIndicatorProjectQuery(),
          status: 'loading',
          requestId,
        },
      };
    }
    case INDICATOR_PROJECT_QUERY_SUCCEEDED:
    case INDICATOR_PROJECT_QUERY_FAILED: {
      const { queryKey, requestId } = action.payload;
      const query = state[queryKey];

      // A reset or a newer attempt invalidates any pending response.
      if (!query || query.status !== 'loading' || query.requestId !== requestId) {
        return state;
      }

      return {
        ...state,
        [queryKey]: action.type === INDICATOR_PROJECT_QUERY_SUCCEEDED
          ? { data: action.payload.data, status: 'succeeded', error: null, requestId: null }
          : { data: [], status: 'failed', error: action.payload.error, requestId: null },
      };
    }
    case RESET_INDICATOR_PROJECT_QUERY: {
      const { queryKey } = action.payload;
      if (!state[queryKey]) {
        return state;
      }
      const remainingQueries = { ...state };
      delete remainingQueries[queryKey];
      return remainingQueries;
    }
    case RESET_INDICATOR_PROJECT_QUERIES:
      return initialState;
    default:
      return state;
  }
};

export default indicatorProjectQueriesReducer;
